module.exports = __webpack_public_path__ + "img/rastreador.c2ba3ab4.png";